module.exports = __webpack_public_path__ + "static/Dreamgirls-Soundbed-MASTERED-VERSION-ccd315e3a44046f83acfaae89e808597.mp3";